import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X, Clock } from "lucide-react";
import { PHONE, PHONE_HREF, LOGO_URL } from "@/data/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/services/water-heater-installation", label: "Installation" },
  { to: "/services/water-heater-repair", label: "Repair" },
  { to: "/services/tankless-conversion", label: "Tankless" },
  { to: "/service-area", label: "Service Area" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="bg-[#0B192C] text-white text-xs sm:text-sm py-2 px-4 flex items-center justify-center gap-2" data-testid="emergency-banner">
        <Clock className="w-3.5 h-3.5 text-[#FF6500]" />
        <span className="font-medium">24/7 Emergency Water Heater Service — Live Answer, Day or Night</span>
      </div>
      <header
        className={`sticky top-0 z-40 transition-[background-color,box-shadow] ${
          scrolled ? "bg-white/80 backdrop-blur-xl shadow-sm border-b border-gray-200/60" : "bg-white/60 backdrop-blur-md"
        }`}
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 sm:h-20">
          <Link to="/" data-testid="header-logo-link" className="flex items-center shrink-0">
            <img src={LOGO_URL} alt="Irvine Water Heater Man" className="h-12 sm:h-16 w-auto" />
          </Link>
          <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-semibold transition-colors ${isActive ? "text-[#FF6500]" : "text-gray-700 hover:text-[#0B192C]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <a
              href={PHONE_HREF}
              data-testid="header-call-btn"
              className="hidden sm:flex items-center gap-2 bg-[#FF6500] text-white font-heading font-bold px-5 py-2.5 rounded-full hover:bg-[#E85C0D] hover:scale-105 transition-[background-color,transform]"
            >
              <Phone className="w-4 h-4" />
              {PHONE}
            </a>
            <a href={PHONE_HREF} data-testid="header-call-btn-mobile" className="sm:hidden flex items-center gap-1.5 bg-[#FF6500] text-white font-bold px-3.5 py-2 rounded-full text-sm">
              <Phone className="w-4 h-4" /> Call
            </a>
            <button data-testid="mobile-menu-btn" className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {open && (
          <nav className="lg:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3" data-testid="mobile-nav">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="font-semibold text-gray-800 py-1.5">
                {l.label}
              </NavLink>
            ))}
          </nav>
        )}
      </header>
    </>
  );
};
